import { render, staticRenderFns } from "./CardAuditoria.vue?vue&type=template&id=f06e5172&scoped=true&"
import script from "./CardAuditoria.vue?vue&type=script&lang=js&"
export * from "./CardAuditoria.vue?vue&type=script&lang=js&"
import style0 from "./CardAuditoria.vue?vue&type=style&index=0&id=f06e5172&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f06e5172",
  null
  
)

export default component.exports